
import { Directive, ComponentFactoryResolver, ViewContainerRef, ComponentRef } from '@angular/core';
import { LeaderboardComponent } from '..';
import { ShellService } from '~/core/services';
import { ModalService } from '~/shared/services';

@Directive({
    selector: '[leaderboardAnchor]',
})
export class LeaderboardAnchorDirective {
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private shellService: ShellService,
        private modalService: ModalService) { }

    createLeaderboardModalPopup(popupComponent: { new(...args: any[]): LeaderboardComponent },
        marketId: number): ComponentRef<LeaderboardComponent> {
        const vcr = this.shellService.getRootElement();
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(popupComponent);
        let componentRef = vcr.createComponent(componentFactory);
        if (this.modalService.isModalDefined()) {
            this.modalService.closeModal();
        }

        this.modalService.setModal(componentRef);

        componentRef.instance.marketId = marketId;
        componentRef.changeDetectorRef.reattach();

        componentRef.instance.subscriptions.push(componentRef.instance.close.subscribe(() => {
            componentRef.destroy();
        }));

        return componentRef;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/views/leaderboard/leaderboard-anchor.directive.ts